import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=2506c72e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=2506c72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2506c72e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2506c72e')) {
      api.createRecord('2506c72e', component.options)
    } else {
      api.reload('2506c72e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=2506c72e&scoped=true&", function () {
      api.rerender('2506c72e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z9Jp6aPrZG4M/JS/comp/PopupDialog.vue"
export default component.exports